// removed by extract-text-webpack-plugin
module.exports = {"card":"_2Msjg2RzFx"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/scripts/components/containers/public/Login/LoginNotice/LoginNotice.module.less
// module id = 962
// module chunks = 3